<template xmlns:v-bind="http://www.w3.org/1999/xhtml" xmlns:v-el="http://www.w3.org/1999/xhtml">
  <div
    v-if="isVisible"
    class="full-screen-creative-video"
    @click="close">
    <div>
      <div class="pane-header">
        <span class="icon"><icon-colored-video /></span>
        <span class="text">{{ name }}</span>
        <div class="actions">
          <button
            class="btn btn-sm btn-default"
            @click="close">
            <span>&times;</span>
          </button>
        </div>
      </div>
      <div class="pane-content">
        <video
          autoplay="autoplay"
          loop="loop"
          controls="controls"
          :src="videoUrl" />
      </div>
    </div>
  </div>
</template>

<script type="text/babel">
  import { IconColoredVideo } from '@/common/icons/colored';

  export default {
    components: {
      IconColoredVideo,
    },
    props: {
      isVisible: {
        type: Boolean,
        default: false,
      },
      name: {
        type: String,
      },
      videoUrl: {
        type: String,
      },
    },
    data() {
      return {};
    },
    methods: {
      close() {
        this.$emit('close');
      },
    },
  };
</script>

<style lang="scss" rel="stylesheet/scss" scoped>
  @use '@/styles/variables' as *;

  #app {
    .full-screen-creative-video {
      background: rgba(0, 0, 0, 0.33);
      display: flex;
      align-items: center;
      align-content: center;
      position: fixed;
      top: 0;
      left: 0;
      bottom: 0;
      right: 0;
      z-index: 10000;

      > div {
        box-shadow: var(--panesShadow);

        margin: auto;
        position: relative;
        max-width: 90%;

        .pane-header {
          box-shadow: none;
        }
        .pane-content {
          background: #fff;
          background-origin: content-box;
          box-shadow: none;
          margin-bottom: 0;
          max-height: 80vh;
          display: flex;
        }

        video {
          border: 0.1rem solid #ccc;
          max-width: 100%;
          max-height: 100%;
          margin-bottom: -0.5rem;
          background: #000;
        }
      }
    }
  }
</style>
